import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-black mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-black`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "Polityka prywatności" }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>Ostatnia akutalizacja: 05 grudzień 2025 r.</p>

            <h2>Punkt 1</h2>
            <p>
            Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych przekazywanych przez Użytkowników w związku z korzystaniem z Serwisu.
            </p>

            <h2>Punkt 2</h2>
            <p>
            Administratorem danych osobowych jest dataGRIT Sp. z o.o. z siedzibą przy ul. Plantowej, 05-806 Nadarzyn, KRS: 0000918039, NIP: 525-287-46-75.<br></br>
            Kontakt z Administratorem jest możliwy poprzez e-mail: kontakt@datagrit.pl lub pisemnie na adres siedziby.
            </p>

            <h2>Punkt 3.</h2>
            <p>
            W trosce o bezpieczeństwo powierzonych nam danych wdrożyliśmy wewnętrzne procedury i zabezpieczenia mające na celu ochronę danych przed dostępem osób nieupoważnionych. Systematycznie monitorujemy zgodność procesów przetwarzania z obowiązującymi przepisami prawa, w tym z Rozporządzeniem RODO, ustawą o ochronie danych osobowych oraz ustawą o świadczeniu usług drogą elektroniczną.
            </p>

            <h2>Punkt 4</h2>
            <p>
            Dane osobowe przetwarzane są na podstawie: 
            <ul>
              <li>zgody wyrażonej przez Użytkownika,</li>
              <li>niezbędności do wykonania umowy lub podjęcia działań na żądanie Użytkownika przed jej zawarciem,</li>
              <li>obowiązków wynikających z przepisów prawa,</li>
              <li>prawnie uzasadnionego interesu Administratora (np. statystyka, bezpieczeństwo serwisu, marketing własny).</li>
            </ul>
            </p>

            <h2>Punkt 5</h2>
            <p>Serwis pozyskuje informacje o użytkownikach i ich zachowaniach w następujący sposób:
            <ul>
              <li>poprzez dobrowolnie wprowadzone dane w formularzach,</li>
              <li>poprzez pliki „cookies” oraz podobne technologie (patrz: Polityka cookies).</li>
            </ul>
            </p>

            <h2>Punkt 6</h2>
            <p>
            Serwis zbiera wyłącznie informacje dobrowolnie podane przez Użytkownika. Podanie danych jest dobrowolne, jednak może być niezbędne do realizacji określonych funkcji Serwisu (np. kontakt, przygotowanie oferty).
            </p>

            <h2>Punkt 7</h2>
            <p>
            Dane podane w formularzu przetwarzane są zgodnie z celem wynikającym z funkcji danego formularza, np. udzielenie odpowiedzi na kontakt, przygotowanie oferty, rejestracja zapytania, wysyłka informacji zwrotnej.
            </p>

            <h2>Punkt 8</h2>
            <p>
            Dane osobowe pozostawione w Serwisie nie będą sprzedawane ani udostępniane osobom trzecim, z wyjątkiem przypadków przewidzianych przepisami prawa lub gdy jest to niezbędne do realizacji celu przetwarzania (np. obsługa serwera, podmioty IT). Wszystkie podmioty przetwarzające dane działają wyłącznie na podstawie umowy powierzenia.
            </p>

            <h2>Punkt 9</h2>
            <p>
            Użytkownik, który umieścił dane w formularzu, ma prawo:
            <ul>
              <li>dostępu do swoich danych,</li>
              <li>sprostowania danych,</li>
              <li>ograniczenia przetwarzania,</li>
              <li>żądania usunięcia danych,</li>
              <li>przeniesienia danych,</li>
              <li>wniesienia sprzeciwu wobec przetwarzania,</li>
              <li>wycofania zgody w dowolnym momencie.</li>
            </ul>
            Realizacja praw jest możliwa po kontakcie z Administratorem.
            </p>
            
            <h2>Punkt 10</h2>
            <p>
            Zastrzegamy sobie prawo do wprowadzania zmian w Polityce Prywatności, na które mogą mieć wpływ: rozwój technologiczny, zmiany prawa dotyczących ochrony danych osobowych, oraz rozwój funkcjonalności Serwisu. O wszelkich zmianach będziemy informować w widoczny i zrozumiały sposób.
            </p>

            <h2>Punkt 11</h2>
            <p>
            W Serwisie mogą znajdować się linki prowadzące do innych stron internetowych. Strony te działają niezależnie od Serwisu www.e-cenowki.pl i nie są przez nas nadzorowane. Zalecamy zapoznanie się z ich politykami prywatności.
            </p>
            
            <h3>W przypadku pytań lub wątpliwości dotyczących niniejszej Polityki Prywatności zapraszamy do kontaktu – dane kontaktowe znajdują się w zakładce „Skontaktuj się z nami”.</h3>
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
